/* eslint-disable import/no-unresolved, import/extensions, no-proto */
import isFn from '@dcode/is/fn/fn';
import getContextKeys from './getContextKeys';

export const mapContext = (command, context, methods) => {
	const names = methods.length ? methods : getContextKeys(context);
	names.forEach((method) => {
		if (isFn(context[method])) {
			context[method] = command(context[method], context);
		}
	});
	return context;
};

export default mapContext;
